import { WEBENGAGE_EVENTS } from "../eventsConfig";
import { cleanWebEngageEventData } from "../cleanWebEngageEventData";
import { trackEvent } from "../webengageEvents";
export const trackOtpRequested = (data) => {
    const cleanedData = cleanWebEngageEventData(data);
    console.log("Auth_Otp_Requested=================", cleanedData);
    trackEvent(WEBENGAGE_EVENTS.Auth.OTP_REQUESTED, cleanedData);
};
export const trackOtpVerified = (data) => {
    const cleanedData = cleanWebEngageEventData(data);
    console.log("Auth_Otp_Verified=================", cleanedData);
    trackEvent(WEBENGAGE_EVENTS.Auth.OTP_VERIFIED, cleanedData);
};
export const trackSignupSuccess = (data) => {
    const cleanedData = cleanWebEngageEventData(data);
    console.log("Auth_Signup_Success=================", cleanedData);
    trackEvent(WEBENGAGE_EVENTS.Auth.SIGNUP_SUCCESS, cleanedData);
};
export const trackAuthSuccess = (data) => {
    const cleanedData = cleanWebEngageEventData(data);
    console.log("Auth_Auth_Sucess=================", cleanedData);
    trackEvent(WEBENGAGE_EVENTS.Auth.AUTH_SUCCESS, cleanedData);
};
export const trackLoginSuccess = (data) => {
    const cleanedData = cleanWebEngageEventData(data);
    console.log("Auth_Login_Sucess=================", cleanedData);
    trackEvent(WEBENGAGE_EVENTS.Auth.LOGIN_SUCCESS, cleanedData);
};
